import * as React from "react";
import { required, SelectInput, TextInput } from "react-admin";
import { TaxClassEditComponent } from ".";
import { StatusEnum } from "src/common/enum";
import Transformer from "src/common/Transformer";
import { Edit, SimpleForm } from "src/enterprise/ra-rbac";
import { Grid } from "@mui/material";

export const TaxClassEdit = () => {
  const transform = (data) => {
    Transformer(data, {
      remove: ["id", "createdAt", "updatedAt"],
      update: {},
    });

    return data;
  };

  return (
    <Edit
      component={TaxClassEditComponent}
      mutationMode="pessimistic"
      transform={transform}
    >
      <SimpleForm>
        <Grid container rowSpacing={1} columnSpacing={2}>
          <Grid item sm={12} lg={8}>
            <TextInput disabled source="id" />
          </Grid>
          <Grid item sm={12} lg={8}>
            <TextInput source="name" validate={required()} />
          </Grid>
          <Grid item sm={12} lg={8}>
            <SelectInput source="status" validate={required()} choices={StatusEnum} />
          </Grid>
        </Grid>
      </SimpleForm>
    </Edit>
  );
};
